import React, { useEffect, useState } from "react";
import IndividualDetailsAccordian from "../IndividualAccountsTab/IndividualDetailsAccordian";
import IndividualEmailCard from "../IndividualAccountsTab/IndividualEmailCard";
import IndividualMobileCard from "../IndividualAccountsTab/IndividualMobileCard";
import axios from "axios";
import { toast } from "react-toastify";
import { Lead_Creation } from "../../../Configuration/API_URL";
import { AESEncryption, ApiResDecrypt } from "../../../CommonMethhods/CommonMethods";
import { ResumeContext } from "../../../CommonMethhods/Context";
import { useClientContext } from "../../../context/ClientContext";

function IndividualAccountSections({activeTab}) {
  const IndiMobileNo = localStorage.getItem("IndiMobileNo");
  const IndiEmail = localStorage.getItem("IndiEmail");
  const storeToken = localStorage.getItem("ssoToken");
  const [resumeVal, setResumeVal] = useState({});
  const [mobileVerify, setMobileVerify] = useState(false);
  const [emailVerify, setEmailVerify] = useState(false);
  const [relation, setRelation] = useState();
  const { selectedClient, shouldPrefill } = useClientContext();

    const resumeJourneyData = async (mobile) => {
        let payloadValue = {
          mobileNo: mobile,
        };
        let encPayload = AESEncryption(payloadValue);
        console.log(payloadValue, "payloadValue");
        try {
          const getRelation = await axios.post(
            Lead_Creation.Resume_journey,
    
            `"${encPayload}"`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${storeToken}`,
                reserv: 1,
              },
            }
          );
    
          const res = ApiResDecrypt(getRelation?.data);
          if (res?.status === 0) {
            const resumeData = res?.data?.verificationDetails;
            setResumeVal(res?.data)
            if(resumeData?.mobileNo?.length > 0){
              setMobileVerify(true);
            } 
            if(resumeData?.email?.length > 0){
              setEmailVerify(true);
            }
          } else {
            toast.error(res?.message);
          }
        } catch (error) {
          console.log(error);
        }
      };

      const selectRelation = async () => {
        try {
          const getRelation = await axios.get(
            Lead_Creation.Select_Relation,
    
            // `"${encPayload}"`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${storeToken}`,
                reserv: 1,
              },
            }
          );
    
          const res = ApiResDecrypt(getRelation?.data);
          if (res?.status === 0) {
            setRelation(res?.data?.nomineeRelation);
          } else {
            toast.error(res?.message);
          }
        } catch (error) {
          console.log(error);
        }
      };

      const resumeHandle=()=>{
        resumeJourneyData(selectedClient?.mobile || IndiMobileNo);
      }

      useEffect(() => {
        if (shouldPrefill && selectedClient?.mobile) {
          resumeJourneyData(selectedClient?.mobile || IndiMobileNo);
        } else {
          setResumeVal({});
          setMobileVerify(false);
          setEmailVerify(false);
          localStorage.removeItem("IndiMobileNo");
          localStorage.removeItem("noAlreadyRegis");
          localStorage.removeItem("saveRelationVal");
          localStorage.removeItem("IndiEmail");
          localStorage.removeItem("mailAlreadyRegis");
          localStorage.removeItem("SaveRelationEmail");
          
        }
      }, [selectedClient, shouldPrefill, activeTab]);

      useEffect(()=>{
        selectRelation();
      }, []);

      
    return (
      <ResumeContext.Provider value={{ resumeHandle }}>
        <div className="individual-acc-section">
            <div className="wrap-mob-email">
                <IndividualMobileCard resumeVal={resumeVal} setMobileVerify={setMobileVerify} relation={relation} activeTab={activeTab}/>
                <IndividualEmailCard resumeVal={resumeVal} 
                  mobileVerify={mobileVerify} 
                  setEmailVerify={setEmailVerify}
                  emailVerify={emailVerify}
                  relation={relation}
                  activeTab={activeTab}
                  />
            </div>
            <IndividualDetailsAccordian resumeVal={resumeVal}
            mobileVerify={mobileVerify}
            emailVerify={emailVerify}
            relation={relation}
            activeTab={activeTab}
            // resumeHandle={resumeHandle}
            />
        </div>
      </ResumeContext.Provider>
    );
}

export default IndividualAccountSections;
